import React from "react";
import Sound from "react-sound";
import { THEMES_TYPE } from "../../config/themes";

export default class DartSound extends React.Component {

  static defaultProps = {
    volume: 100
  };

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      trackId: 0
    };

    this.resetPlaylist = this.resetPlaylist.bind(this);
    this.setTrack = this.setTrack.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState) {
    return nextState.playlist !== this.state.playlist
      || nextState.trackId !== this.state.trackId
  }

  setTrack(track, theme) {
    const currentTheme = THEMES_TYPE.find((item) => item.value === theme);
    if (currentTheme && currentTheme.config && currentTheme.config[track]) {
      let playlist = currentTheme.config[track];
      if (!Array.isArray(playlist)) {
        playlist = [playlist]
      }
      const trackId = 0;
      const playlistShuffled = this.shuffle(playlist);
      this.setState({ playlist: playlistShuffled, trackId })
    }
  }


  nextTrack() {
    const { playlist, trackId } = this.state;
    let nextTrackId = (trackId === (playlist.length - 1)) ? 0 : trackId + 1;
    this.setState({ trackId: nextTrackId })
  }

  resetPlaylist() {
    this.setState({ playlist: [], trackId: 0 })
  }


  render() {
    const { playlist, trackId } = this.state;
    const { volume, shuffle } = this.props;
    let audioProps = {};
    if (playlist) {
      audioProps = {
        playStatus: Sound.status.PLAYING,
        url: playlist[trackId],
        autoLoad: true,
        volume,
        onFinishedPlaying: shuffle ? () => this.nextTrack() : () => this.resetPlaylist()
      };

      return <Sound {...audioProps} />;
    } else {
      return <Sound mutted={true} url={""} playStatus={Sound.status.STOPPED} />;
    }
  }

  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }

}
